import { render, staticRenderFns } from "./PollWeek.vue?vue&type=template&id=37bb4cbc"
import script from "./PollWeek.vue?vue&type=script&lang=js"
export * from "./PollWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports